<template>
  <div id="pageTitleDesktop">
    <!-- TITLE -->
    <h2>{{title}}</h2>

    <!--POSITION, CONTACT (ONLY ON TEAM PAGES) -->
    <div v-if="position" v-html="newLineText(position)" class="position-kontakt type-xs"></div>
    <div v-if="kontakt" v-html="newLineText(kontakt)" class="position-kontakt type-xs"></div>

    <!-- BACK LINK-->
    <div class="back-link">
      <router-link class="type-xs" :to="'/'">
        <span v-if="$i18n.locale == 'default'">← Zurück zu Basel Academy</span>
        <span v-else>← Back to Basel Academy</span>
      </router-link>
    </div>
  </div>

</template>

<script>
export default {
  name: "PageTitleDesktop",
  props: {
    title: String,
    position: String,
    kontakt: String,
  },
  methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
}
</script>

<style lang="scss" scoped>

h2 {
  padding-top: 1.8rem;
  padding-bottom: 1.4rem;
}

.position-kontakt {
  padding-bottom: 3rem;
}

#pageTitleDesktop {
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 0.8rem;
  margin-left: 1.6rem;
  margin-bottom: 1.6rem;
  width: calc(33.3333333% - 3.0rem);
  height: 100vh;
}

.team-bild {
  width: 50%;
  padding-bottom: 3rem;
}

.back-link {
  position: fixed;
  bottom: 1.2rem;
  & a {
    display: block;
  }
}
</style>